export var typescriptVersion = "3.5.1";
